import { dataVideoUpload } from 'dls-icons-data'
import { createIcon } from '../common'

const IconVideoUpload = /*#__PURE__*/createIcon(dataVideoUpload)
export default IconVideoUpload
